<mat-accordion *ngIf="regions.length > 0">
  <mat-expansion-panel
    *ngFor="let region of regions; index as regionId"
    [(expanded)]="expanded[regionId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <span class="header-title" fxFlex>
          {{ region.name }}
          <span *ngIf="region.name">
            &mdash;
            <span *ngIf="region.all">tutte le città</span>
            <span *ngIf="!region.all">{{ region.cities.length }} città</span>
          </span>
        </span>
        <div class="header-actions">
          <button
            type="button"
            mat-icon-button
            matTooltip="Rimuovi"
            (click)="removeRegion(region, nation)"
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Regione</mat-label>
        <input
          required
          name="nation_{{ nationId }}_region_{{ regionId }}"
          matInput
          [(ngModel)]="region.name"
          type="text"
          required
        />
      </mat-form-field>

      &nbsp;&nbsp;&nbsp;
      <span>Sei esperto di tutte le città in {{ region.name }}?</span>
      &nbsp;&nbsp;&nbsp;
      <mat-slide-toggle
        [(ngModel)]="region.all"
        name="nation_{{ nationId }}_region_{{ regionId }}_all"
      >
        {{ region.all ? "Sì, tutte" : "No, solo alcune" }}</mat-slide-toggle
      >
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" *ngIf="!region.all" fxFlex>
        <mat-label>Città</mat-label>
        <mat-chip-list #chipList aria-label="Città">
          <mat-chip
            *ngFor="let city of region.cities"
            [removable]="true"
            (removed)="removeCity(city, region)"
          >
            {{ city.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            required
            placeholder="Aggiungi città..."
            [matChipInputFor]="chipList"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addCity($event, region)"
          />
        </mat-chip-list>
      </mat-form-field>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="add-button-container" *ngIf="!nation.all">
  <a mat-raised-button (click)="addRegion(nation)">
    <mat-icon>add</mat-icon> Aggiungi una regione
  </a>
</div>
